import { API_PATH } from "../../utils/Constants";
import EndpointsBase from "../EndpointsBase";
import ServerRequestWrapper from "../ServerRequestWrapper";

export interface ICancelledItemRestockRequest {
  itemId: number;
  scannedQuantity: number;
  missingQuantity: number;
  operatorAssignedShelf: string;
  deliveryId: number;
}

export interface ICancelledItemRestockResponse {
  deliveryId: number;
  requestedShelf: string;
  suggestedShelf: string | null;
  isValid: boolean;
}

// both are used
export interface IItemRestockRequest extends ICancelledItemRestockRequest {}
export interface IItemRestockResponse extends ICancelledItemRestockResponse {}

class ConveyorBoxClient extends EndpointsBase {
  _server = new ServerRequestWrapper(API_PATH + "/api");

  restockCancelledRx = async (
    barcode: string,
    payload: ICancelledItemRestockRequest
  ): Promise<ICancelledItemRestockResponse> => {
    return this._sendRequest({
      method: `/rx/boxes/${barcode}/items/cancelled/restock`,
      headers: this._getAuthHeader(),
      run: this._server.postData,
      data: payload,
    });
  };
}

export default new ConveyorBoxClient();
